<app-table
    [items]="data()"
    [columns]="columns()"
    translatePrefix="dashboard.nearEndVouchers."
    [hideCheckboxes]="true"
    [smallButtons]="true"
>
    <ng-template pTemplate="voucherTo" let-item="item" let-data="data">
        @if (item.closureDate) {
            <div [class.text-warning]="item.closureDate"
                [pTooltip]="('folder.voucher.listTable.originalValidTo' | translate) + ': ' + (item.validTo | shortDate)">{{ data | shortDate }}
            </div>
        } @else {
            <div>{{ data | shortDate }}</div>
        }
    </ng-template>
</app-table>
